<template>
  <div class="layout">
    <header class="header">
      <v-header></v-header>
    </header>
    <router-view class="container main-content"></router-view>
    <tool-bar class="toolbar"></tool-bar>
    <footer class="footer">
      <v-footer></v-footer>
      <!-- <div class="copy-right">
        <img src="../../assets/icon_ba.png" alt="">
        <span>粤公网安备 44030402000581号</span>
      </div> -->
    </footer>
  </div>
</template>

<script>
import vHeader from './Header'
import vFooter from './Footer'
import ToolBar from './ToolBar'
export default {
  components: {
    vHeader,
    vFooter,
    ToolBar,
  },
}
</script>

<style scoped>
.header {
  height: 120px;
  background-color: #475669;
  /* top: 0px; */
  /* left: 0px; */
  width: 100%;
  line-height: 120px;
  color: #fff;
  z-index: 100;
  /* position: fixed; */
}

.main-content {
  padding: 20px 0;
  overflow: auto;
}

.footer {
  background-color: #41566a;
  width: 100%;
  color: #fff;
  z-index: 1000;
  position: relative;
}

.copy-right {
  background: #212831;
  text-align: center;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  font-family: "MicrosoftYaHei";
  color: rgb(233, 244, 255);
}

.copy-right img {
  height: 18px;
  vertical-align: text-bottom;
}

.toolbar {
  position: fixed;
  right: 6px;
  bottom: 10px;
  /* padding-bottom: 73px; */
  z-index: 1100;
}
</style>



// WEBPACK FOOTER //
// Layout.vue?3cc945c2